module.exports = __webpack_public_path__ + "static/media/arjun_deodhar.8240a424.png";